module.exports = __webpack_public_path__ + "static/media/Facebook.e85ac62c.svg";